import React, { useState, useEffect } from 'react';
import CoursePage from './coursePage';
import EnrolledCourse from './enrolledCourse';
import { useAuth } from '../context/AuthContext';
import { useParams } from 'react-router-dom';
import globals from '../globals';
import LoadingPage from '../error_page/loadingPage';
import ErrorPage from '../error_page/errorPage';
import SomethingWentWrongPage from '../error_page/somethingWentWrong';

const CourseSwitch = () => {
    const {id} = useParams();
    const {token} = useAuth();
    const [enrolled, setEnrolled] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [notFound, setNotFound] = useState(false);
    const [course, setCourse] = useState(null);
    const [showPublish, setShowPublish] = useState(false);

    useEffect(() => {
        if (token) {
        fetch(`${globals.apiUrl}/courses/enrollments/with-enrollment-info/${id}`,
            {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        )
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                }
                if (response.status === 404) {
                    setLoading(false);
                    setNotFound(true);
                    throw new Error('Course not found');
                }
                setError(true);
            })
            .then(data => {
                //console.log(data);
                setEnrolled(data.is_enrolled);
                setCourse({...data.course});
                setShowPublish(data.show_publish);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error:', error);
                });
        }else{
            fetch(globals.apiUrl + `/courses/${id}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            )
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                }
                if (response.status === 404) {
                    setLoading(false);
                    setNotFound(true);
                    throw new Error('Course not found');
                }
                setError(true);
            })
            .then(data => {
                setCourse({...data, showChat: false});
                setLoading(false);
            })
            .catch(error => {
                console.error('Error:', error);
            });
        }
    }, [id]);
    
    return (
        loading ? <LoadingPage /> : notFound ? <ErrorPage /> : error ? <SomethingWentWrongPage /> : enrolled ? <EnrolledCourse course={course} /> : <CoursePage course={course} showPublish={showPublish}/>
    )
}

export default CourseSwitch;